import script from "./SignatureModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignatureModal.vue?vue&type=script&lang=ts&setup=true"

import "./SignatureModal.vue?vue&type=style&index=0&id=b65005fa&lang=css"

const __exports__ = script;

export default __exports__